import React, { Component } from 'react';
import { debounce } from 'helpers/helper';

export default class Gallery extends Component<any,any> {
  private searchInputRef;
  constructor(props) {
    super(props)
    this.state = {
       selectedImageUrl:[],
       resultingImages:[]
    }
  }
  handleSearch = (searchWord) =>{
      let matching_images = [];
      this.props.imageurlsList.map(imgObj => {
          if(imgObj.name.toLowerCase().includes(searchWord)){
                matching_images.push(imgObj);
          }
          return imgObj;
      })
      this.setState({resultingImages:matching_images});
  }

  pushImageUrl = (url) =>{
      let previousSelected = this.state.selectedImageUrl;
      if(!previousSelected.includes(url)){
      previousSelected.push(url);
      }
      else{
        const index = previousSelected.indexOf(url);
        if (index > -1) {
          previousSelected.splice(index, 1); // 2nd parameter means remove one item only
        }
      }
      this.setState({selectedImageUrl:previousSelected});
      console.log(this.state.selectedImageUrl);
  }

  render() {
    let {imageurlsList} = this.props;
    return (
    <div id="id01" className="gallery-modal">
        <div className="popupInner">
            <div className="gallery-popupHead">
                <div>
                      <p>Select/Search A Image</p>
                </div>
                <div>
                    <input type={'search'} style={{height:'90%',fontSize:'1.2rem'}} placeholder={'search'} onChange={(e) => {debounce(this.handleSearch(e.target.value),1000)}}></input>
                </div>
            </div>
            <div className="gallery">
              {
                  (this.state.resultingImages.length !== 0) ?
                  this.state.resultingImages.map((imageObj,index) =>{
                    return <div className={`image${this.state.selectedImageUrl?.includes(imageObj.url)?'-active':''}`}>
                                {/* <img crossOrigin="anonymous" className={'gallery-image'} src={`${imageObj.url}`} onClick={()=> this.setState({selectedImageUrl:imageObj.url})} /> */}
                                <img crossOrigin="anonymous" alt="ScImage"className={'gallery-image'} src={`${imageObj.url}`} onClick={() => {this.pushImageUrl(`${imageObj.url}`)}}/>
                                <label className='image-label'>{imageObj.name}</label>
                            </div>
                  }) :
                  imageurlsList?.map((imageObj,index) =>{
                          return <div className={`image${this.state.selectedImageUrl?.includes(imageObj.url)?'-active':''}`}>
                                {/* <img crossOrigin="anonymous" className={'gallery-image'} src={`${imageObj.url}`} onClick={()=> this.setState({selectedImageUrl:imageObj.url})} /> */}
                                <img crossOrigin="anonymous" alt="ScImage" className={'gallery-image'} src={`${imageObj.url}`} onClick={() => {this.pushImageUrl(`${imageObj.url}`)}}/>
                                <label className='image-label'>{imageObj.name}</label>
                              </div>
                  })
              }
            </div>
            <div className="popupFooter" style={{justifyContent: "flex-end"}}>
                <div className="close-btn" onClick={() => this.props.handleAddGalleryImage(this.state.selectedImageUrl)}>Add To Canvas</div>
                <div className="close-btn" onClick={() => this.props.handleClose()}>Close</div>
            </div>
        </div>
    </div>
    )
  }
}